import { useRef, type MutableRefObject } from "react";
import type { ChartStore } from "~types/types";

/**
 * Keep a mutable ref that always points to the latest ChartStore.
 * Replaces the repeated useRef(store); ref.current = store pattern.
 */
export function useStoreRef(store: ChartStore): MutableRefObject<ChartStore> {
  const ref = useRef(store);

  ref.current = store;

  return ref;
}
